import React from 'react';

import { Column, List, AutoSizer } from 'react-virtualized';
import MediaQuery from 'react-responsive';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import defaultRowRenderer from 'components/shared/ReactVirtualizedTable/DefaultRowRenderer';
import ReactVirtualizedTable from 'components/shared/ReactVirtualizedTable';

import { toFriendlyDateTimeString } from 'helpers/Formatter';

class LogsTable extends React.Component {
  state = { anchorEl: null, rowData: {} };

  handleClick = (event, rowData) => {
    this.setState({ anchorEl: event.currentTarget, rowData: rowData });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, rowData: {} });
  };

  changeReadStatus = async isRead => {
    const { rowData } = this.state;
    rowData['read'] = isRead;

    await this.props.createOrUpdateLog(rowData);
    this.handleClose();
  };

  openLog = (event, rowData) => {
    // Because we have two onClick functions (one for the row, and one for
    // the row button), we want to prevent both from triggering
    if (event._dispatchListeners.length === 2) return;
    this.props.openLog(rowData);
  };

  render() {
    return (
      <React.Fragment>
        <MediaQuery query="(min-device-width: 750px)">{this._renderDesktopView()}</MediaQuery>

        <MediaQuery query="(max-device-width: 750px)">{this._renderMobileView()}</MediaQuery>
      </React.Fragment>
    );
  }

  _renderDesktopView = () => (
    <React.Fragment>
      {this._renderStatusMenu()}
      <ReactVirtualizedTable
        data={this.props.data}
        rowRenderer={defaultRowRenderer}
        onRowClick={({ rowData, event }) => this.openLog(event, rowData)}
        grouped
      >
        <Column
          width={120}
          label="Status"
          dataKey="read"
          cellRenderer={({ cellData, rowData }) => (
            <MenuButton
              rowData={rowData}
              anchorEl={this.state.anchorEl}
              handleClick={this.handleClick}
            />
          )}
        />
        <Column width={225} label="Title" dataKey="title" style={{ textTransform: 'capitalize' }} />
        <Column
          width={175}
          label="Type"
          dataKey="log_type_friendly"
          style={{ textTransform: 'capitalize' }}
        />
        <Column
          width={185}
          label="Log Date"
          dataKey="log_date"
          cellRenderer={({ cellData }) => toFriendlyDateTimeString(cellData)}
        />
        <Column width={170} label="Reported By" dataKey="reported_by" />
      </ReactVirtualizedTable>
    </React.Fragment>
  );

  _renderMobileView = () => (
    <React.Fragment>
      {this._renderStatusMenu()}
      <div className="mobile_card" style={{ height: 'calc(100% - 43px)' }}>
        {this._renderMobileLogs()}
      </div>
    </React.Fragment>
  );

  _renderStatusMenu = () => (
    <Menu
      id="simple-menu"
      anchorEl={this.state.anchorEl}
      open={Boolean(this.state.anchorEl)}
      onClose={this.handleClose}
    >
      <MenuItem onClick={() => this.changeReadStatus(true)} selected={this.state.rowData.read}>
        <span>
          <span className="ticket_status_label_title small inactive">Read</span>
        </span>
      </MenuItem>

      <MenuItem onClick={() => this.changeReadStatus(false)} selected={!this.state.rowData.read}>
        <span>
          <span className="ticket_status_label_title small closed">Unread</span>
        </span>
      </MenuItem>
    </Menu>
  );

  _renderMobileLogs = () => {
    if (this.props.data.length === 0) {
      return (
        <div id="mobile_card">
          <div className="row">
            <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.5)', marginTop: '13px' }}>
              You don&rsquo;t have any unread logs
            </p>
          </div>
        </div>
      );
    }

    return (
      <AutoSizer>
        {({ height, width }) => (
          <List
            rowCount={this.props.data.length}
            rowHeight={80}
            rowRenderer={this._mobileRowRender}
            width={width}
            height={height}
          />
        )}
      </AutoSizer>
    );
  };

  _mobileRowRender = ({ key, index, style }) => {
    const row = this.props.data[index];

    return (
      <div key={key} style={style} onClick={() => this.openLog(row)}>
        <div className="row">
          <div className="mobile_header">
            <b style={{ fontFamily: 'Circular-Bold' }}>{row.title}</b>
          </div>

          <div style={{ float: 'right', marginTop: '-10px' }}>
            <MenuButton
              rowData={row}
              style={{ padding: 0, marginTopminWidth: '20px' }}
              handleClick={this.handleClick}
            />
          </div>
        </div>

        <div className="row">
          <div className="mobile_subheader">
            <b style={{ fontFamily: 'Circular' }}>{row.log_type_friendly}</b>
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            <b style={{ fontFamily: 'Circular' }}>{row.reported_by}</b>
          </div>
        </div>
      </div>
    );
  };
}

const MenuButton = ({ rowData, anchorEl, style, handleClick }) => (
  <Button
    aria-owns={anchorEl ? 'simple-menu' : null}
    aria-haspopup="true"
    onClick={event => handleClick(event, rowData)}
    style={{ padding: 0, ...style }}
  >
    <span>
      <span className={`ticket_status_label_title small ${rowData.read ? 'inactive' : 'closed'}`}>
        {rowData.read ? 'Read' : 'Unread'}
      </span>
    </span>
  </Button>
);

export default LogsTable;
